import styled from 'styled-components';

import { EntityHeader } from '~/modules/entity-header/EntityHeader';
import { OverviewKeyValues } from '~/modules/overview-key-values/OverviewKeyValues';
import { ChartPrice } from '~/modules/simple-chart/components/chart-price/ChartPrice';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  padding-bottom: 40px;
  gap: 24px;
`;

export const StyledOverviewKeyValuesWrapper = styled.div`
  ${OverviewKeyValues.Styled.KeyValuesList} {
    column-gap: 20px;
  }
`;

export const StyledEntityHeader = styled(EntityHeader)`
  margin: 0;
  padding: 12px 0;
`;

export const ChartWrapper = styled.div`
  gap: 12px;
`;

export const StyledChartPrice = styled(ChartPrice)`
  padding-bottom: 2px;
`;
